import { DateTime } from 'luxon';
import { useState } from 'react';
import { ValueOrDash } from 'ui-components';
import { formattedDuration } from 'ui-format-utils';
import { useInterval } from 'usehooks-ts';

type Props = {
  calledAt: string;
  heldAt?: string;
};

export default function CustomerPickupTime({ calledAt, heldAt }: Props): React.ReactNode {
  const called = DateTime.fromISO(calledAt);
  const held = heldAt ? DateTime.fromISO(heldAt) : null;
  const now = DateTime.now();

  const difference = (start: DateTime, end: DateTime): number => {
    return end.diff(start, 'seconds').as('seconds');
  };

  const initial = held ? difference(called, held) : difference(called, now);

  const [pickupTime, setPickupTime] = useState<number>(initial);

  useInterval(() => {
    if (!held) {
      setPickupTime(difference(called, DateTime.now()));
    }
  }, 3000);

  if (!pickupTime) {
    return <ValueOrDash value={null} />;
  }

  return formattedDuration(pickupTime, { hours: true, showCa: false, showZero: true });
}
